import { AssetsBaseUrl } from '../../assets';
import HintPopup from '../../components/HintPopup/HintPopup';

import { useTranslation } from '@web_opxp/features';
import './ChallengeInfo.scss';

const ChallengeInfo = () => {
  const { t } = useTranslation();
  const iconPath = `${AssetsBaseUrl}/feature/fire.png`;

  return (
    <div className="challenge-info">
      <div className="row">
        <div className="col-6">
          <div className="challenge-info-container">
            <img className="challenge-info-icon" alt="challenge" src={iconPath} />
            <div>
              <h4 className="challenge-info-container-title">{t('ChallengeInfo.Title')}</h4>
              <p className="challenge-info-container-text">{t('ChallengeInfo.Text')}</p>
            </div>
            <HintPopup className="challenge-info-hint">{t('ChallengeInfo.Hint')}</HintPopup>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeInfo;
